import React from "react";
import { Link } from "react-router-dom";

const BookACall = () => {
  return (
    <section className="coding-skill space-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="heading text-left">
              We Carry more Than Just <br /> Good Coding Skills.
            </h1>
            <Link to={`/contact-us`} className="btn btn-orange">
              Book a call
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookACall;
